import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/trakr-logos.svg")